import { RouteRecordRaw } from "vue-router";
import { LAYOUT } from "../constants";
import { ManagerType } from "../constants";

export default {
  path: "/official",
  redirect: "/official/list",
  name: "official",
  component: LAYOUT,
  meta: {
    roles: ManagerType.OrganizationReviewer,
    title: "队伍官员管理",
    order: 90,
  },
  children: [
    {
      path: "list",
      name: "OfficialPage",
      component: () => import("@/views/official/OfficialPage.vue"),
      meta: {
        title: "队伍官员管理",
        roles: ManagerType.OrganizationReviewer,
        icon: "fluent-emoji-high-contrast:man-judge",
      },
      children: [
        {
          path: "detail/:idNumber",
          name: "OfficialDetailPage",
          component: () => import("@/views/official/OfficialDetailPage.vue"),
          meta: {
            title: "队伍官员详情",
            roles: ManagerType.OrganizationReviewer,
            hideMenu: true,
          },
        },
      ],
    },
  ],
} as RouteRecordRaw;
